import React, { FC } from 'react';

import WhitePaperShowPageContainer from 'buyside/components/presentation/WhitePaper/WhitePaperShowPageContainer';

import ErrorBoundary from 'buyside/components/presentation/ErrorBoundary/errorBoundary';

const WhitePaperShowPageRoot: FC<{ whitePaperId: string }> = ({ whitePaperId }) => {
  if (!whitePaperId) return;

  return (
    <ErrorBoundary pageName="macro/thematic research submission">
      <WhitePaperShowPageContainer id={whitePaperId} />
    </ErrorBoundary>
  );
};

export default WhitePaperShowPageRoot;
